import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-doctor2_diagnosis-enter-disease-yundong",
  "use": "icon-doctor2_diagnosis-enter-disease-yundong-usage",
  "viewBox": "0 0 22 22",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 22 22\" id=\"icon-doctor2_diagnosis-enter-disease-yundong\">\r\n  <g transform=\"translate(-657 -704)\">\r\n    <path class=\"a\" d=\"M63.04,60.5c-1.43-1.442-4.291-3.545-7.1.733-2-1.394-5.22-.122-5.22-.122-.306-6.723,1.015-7.285,1.259-7.212.636.2.367,1.076,1.711,1.992.978.672,4.364-2.3,3.643-3.948-.342-.795-3.569-2.115-5.892-1.015C49.19,52,45.816,57.4,44.215,61.493a17.961,17.961,0,0,0-1.3,5.464,1.325,1.325,0,0,0,.5,1.125c2.139,1.687,6.356,2.9,9.437,2.9,9.5,0,11.906-4.694,12.016-6.87A5.831,5.831,0,0,0,63.04,60.5Zm-5.99,5.55a3.77,3.77,0,0,1-2.64,1.381c-.086,0-.159.012-.244.012a5.8,5.8,0,0,1-3.386-1.357.364.364,0,0,1,.477-.55c.122.11,2.995,2.579,5.232.037A.367.367,0,0,1,57,65.54.347.347,0,0,1,57.05,66.053Z\" transform=\"translate(614.083 654.254)\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/doctor2_diagnosis-enter-disease-yundong.svg
// module id = 35hT
// module chunks = 10